export const COUNTRY_OPTION_FORM = "country_option_form";
export const COUNTRY_OPTION_LIST = [];

export const pushItemsToIndex = (
  list: any[] = [],
  items: any[] = [],
  index = 0
) => {
  return [...list.slice(0, index), ...items, ...list.slice(index, list.length)];
};

export const CurrencyOptions = pushItemsToIndex(
  COUNTRY_OPTION_LIST,
  [
    {
      countryId: 1,
      value: 1, // curency_id
      label: "SGD"
    },
    {
      countryId: 1,
      value: 73, // curency_id
      label: "SG (USD)"
    },
    {
      countryId: 2,
      value: 2, // curency_id
      label: "MYR"
    },
    {
      countryId: 3,
      value: 3, // curency_id
      label: "HKD"
    },
    {
      countryId: 3,
      value: 73, // curency_id
      label: "HK (USD)"
    },
    {
      countryId: 16,
      value: 11, // curency_id
      label: "AUD"
    }
  ],
  0
);

export const CountryOptions = [
  {
    label: "Singapore",
    value: 1
  },
  {
    label: "Malaysia",
    value: 2
  },
  {
    label: "Hong Kong",
    value: 3
  },
  {
    label: "Australia",
    value: 16
  }
];
